document.addEventListener("DOMContentLoaded", function() {
    Fancybox.bind(".product-gallery li", {
    Thumbs: false,
    Toolbar: true,
    animated: true,
    });
});

$(document).ready(function() {
    $('.text_faq_title_wrapper').click(function(e) {
        e.preventDefault();
        const item = $(this).closest('.text_faq_item_wrapper');
        $('.text_faq_item_wrapper').not(item).removeClass('show');
        item.toggleClass('show');
    });
});


$('.product-list-slider').each(function () {
  let $slider = $(this);

  $slider.slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows:true,
    // autoplay: true,
    // autoplaySpeed: 5000,
    prevArrow: '<button type="button" class="left"></button>',
    nextArrow: '<button type="button" class="right"></button>',
    rows: 0,
    appendDots: $slider.parent().find('.product-list-nav'),
    appendArrows: $slider.parent().find('.product-list-nav'),
    responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
        breakpoint: 481, 
        settings: 'unslick'
      }

  ]
  });
});


$('.home_values_items_wrapper').each(function () {
  let $slider_values = $(this);

  $slider_values.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows:true,
    // autoplay: true,
    // autoplaySpeed: 5000,
    prevArrow: '<button type="button" class="left"></button>',
    nextArrow: '<button type="button" class="right"></button>',
    rows: 0,
    appendDots: $slider_values.parent().find('.values-list-nav'),
    appendArrows: $slider_values.parent().find('.values-list-nav'),
    responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  });
});


$(document).ready(function() {
  $('.anitas_burger').click(function(event) {
    event.preventDefault();
      $(this).toggleClass('active');
      $('.anitas_header_nav').toggleClass('active');
      $('html,body').toggleClass('anitas_hidden');
  });
});


$(document).ready(function () {

  $('.anitas_header_nav_link').on('click', function (e) {
    e.preventDefault();

    const parent = $(this).parent();
    const submenu = parent.find('.anitas_sub_items');
    submenu.slideToggle(200);
  });
});

$(window).scroll(function() {
    $('.animated').each(function(){
        var Pos = $(this).offset().top;
        var topOfWindow = $(window).scrollTop();
        var height = $(window).height();
        if (Pos < topOfWindow + height - 150) {
            $(this).addClass("show");
        }
        else {
            $(this).removeClass("show");
        }
    });
});


// //Show modal after 30sec and create cookie    
//     window.addEventListener('load', function() {
//     if (getCookie('modal_shown2') == null) {
//         setTimeout(function() {
//             setCookie('modal_shown2', 'yes', 1);
//             $('.modal').show(400);
//         }, 10);
//       }
//     });
//   function setCookie(name, value, days) {
//     var expires = '';
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = '; expires=' + date.toUTCString();
//     }
//     document.cookie = name + '=' + (value || '') + expires + '; path=/';
//   }
//   function getCookie(name) {
//     var nameEQ = name + '=';
//     var ca = document.cookie.split(';');
//     for (var i = 0; i < ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//     }
//     return null;
//   }
//   function eraseCookie(name) {
//     setCookie(name, '', {
//         'max-age': -1
//     });
//   }
  
//   $(document).ready(function() {
//   $('.modal_close').click(function(event) {
//     event.preventDefault();
//       $(".modal").hide();
//   });
// });

// $(document).ready(function() {
//   $('.modal-js').click(function(event) {
//     event.preventDefault();
//       $(".modal").show();
//   });
//   }); 